/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_SuperyachtInputs */

const en_val_superyacht = /** @type {(inputs: Val_SuperyachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superyacht`)
};

const es_val_superyacht = /** @type {(inputs: Val_SuperyachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superyate`)
};

const fr_val_superyacht = /** @type {(inputs: Val_SuperyachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superyacht`)
};

const de_val_superyacht = /** @type {(inputs: Val_SuperyachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superyacht`)
};

const ja_val_superyacht = /** @type {(inputs: Val_SuperyachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スーパーヨット`)
};

const zh_val_superyacht = /** @type {(inputs: Val_SuperyachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`超级游艇`)
};

const ar_val_superyacht = /** @type {(inputs: Val_SuperyachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يخت فاخر (Superyacht)`)
};

const id_val_superyacht = /** @type {(inputs: Val_SuperyachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapal Pesiar Mewah (Superyacht)`)
};

const it_val_superyacht = /** @type {(inputs: Val_SuperyachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superyacht`)
};

const ru_val_superyacht = /** @type {(inputs: Val_SuperyachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Суперяхта`)
};

const pt_val_superyacht = /** @type {(inputs: Val_SuperyachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superiate`)
};

const ko_val_superyacht = /** @type {(inputs: Val_SuperyachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`슈퍼요트`)
};

/**
* | output |
* | --- |
* | "Superyacht" |
*
* @param {Val_SuperyachtInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_superyacht = /** @type {((inputs?: Val_SuperyachtInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_SuperyachtInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_superyacht(inputs)
	if (locale === "es") return es_val_superyacht(inputs)
	if (locale === "fr") return fr_val_superyacht(inputs)
	if (locale === "de") return de_val_superyacht(inputs)
	if (locale === "ja") return ja_val_superyacht(inputs)
	if (locale === "zh") return zh_val_superyacht(inputs)
	if (locale === "ar") return ar_val_superyacht(inputs)
	if (locale === "id") return id_val_superyacht(inputs)
	if (locale === "it") return it_val_superyacht(inputs)
	if (locale === "ru") return ru_val_superyacht(inputs)
	if (locale === "pt") return pt_val_superyacht(inputs)
	return ko_val_superyacht(inputs)
});